import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { getRole } from "../shared/auth/getRole";

export default function RoleRoute({ seekerComponent: SeekerComp, providerComponent: ProviderComp }) {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex flex-col items-center justify-center bg-white dark:bg-gray-900 transition-colors">
                <div className="w-16 h-16 rounded-full border-4 border-brand-blue border-t-transparent animate-spin mb-4"></div>
                <p className="text-gray-500 font-medium animate-pulse mt-4">Loading application...</p>
            </div>
        );
    }

    // 🧘 Guest Support: If no user, default to Seeker experience
    if (!user) {
        return SeekerComp ? <SeekerComp /> : <Navigate to="/login" replace />;
    }

    const role = getRole(user);

    // 🛡️ ONBOARDING GUARD: Check if profile is complete
    const isComplete = role === "PROVIDER" 
        ? !!user.provider?.username 
        : !!user.seeker?.username;
    
    const hasCategories = role === "PROVIDER"
        ? (user.provider?.categories?.length > 0)
        : (user.seeker?.categories?.length > 0);

    if (user && (!isComplete || !hasCategories) && !user.isGuest) {
        return <Navigate to="/signup-flow?mode=google_finish" replace />;
    }

    if (role === "SEEKER" && SeekerComp) {
        return <SeekerComp />;
    }

    if (role === "PROVIDER" && ProviderComp) {
        return <ProviderComp />;
    }

    // Fallback if role is missing or invalid
    return <Navigate to="/login" replace />;
}
